(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'torso/modules/Collection', './InsurancePolicyDetailsModel', 'services/insurancePolicyDetailsExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var insurancePolicyDetailsExtService = require('./../urls').insurancePolicyDetailsExtService;
    module.exports = factory(require('underscore'), require('backbone-torso/modules/Collection'), require('./InsurancePolicyDetailsModel'), insurancePolicyDetailsExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, TorsoCollection, InsurancePolicyDetailsModel, insurancePolicyDetailsExtService) {
  'use strict';

  /**
   * Receives insurance from the InsurancePolicyDetailsExtService which serves the InsurancePolicyDetailsDTO resource
   * @class InsurancePolicyDetailsCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: InsurancePolicyDetailsModel,
    fetchHttpAction: 'POST',
    url: insurancePolicyDetailsExtService
  }))();
}));
